<template>
  <div
    class="flexbox chatcontentbox"
    :style="{
      justifyContent: senderIsSelf ? 'flex-end' : 'flex-start',
      paddingRight: senderIsSelf ? '0px' : '40%',
      paddingLeft: senderIsSelf ? '40%' : '0px',
    }"
  >
    <div :class="senderIsSelf ? 'pop-right' : 'pop-left'">
      <Expression v-if="data.type == 'text' || data.type == 'txt'" :text="data.content" />
      <div v-else-if="data.type == 'img' && (+vip === 2 || isService == 1)" class="chat-image">
        <img v-if="!imageFailed" :key="imageRetry" :src="imageSource" :alt="$t('chat.photo')"
          referrerpolicy="no-referrer" @load="onImageLoad" @error="imageFailed = true"
          @click="openImage" />
        <span v-if="!imageLoaded && !imageFailed" class="image-loading">{{ $t('chat.loadingImage') }}</span>
        <div v-if="imageFailed" class="image-error">
          {{ $t('chat.loadImageFailed') }}
          <button v-if="!data.preview_url" type="button" @click.stop="reloadImage">{{ $t('chat.retryImage') }}</button>
        </div>
      </div>
      <div v-else-if="data.type == 'img'" class="image-slot">
        <i style="font-size: 30px" class="el-icon-picture-outline"></i>
      </div>
      <div v-if="senderIsSelf && data.type == 'img'" class="send-status" :class="{ failed: data.status === 'failed' }" aria-live="polite">
        {{ statusText }}
        <button v-if="data.status === 'failed' && canRetry" type="button" @click.stop="retrySend">{{ $t('chat.retry') }}</button>
        <button v-if="data.status === 'failed'" type="button" @click.stop="discardImage">{{ $t('chat.removePhoto') }}</button>
      </div>
      <div class="ndate">{{ data.ndate }}</div>
    </div>
    <el-image-viewer @close="closeImgViewer" :url-list="imageList" v-if="showImageViewer"/>

  </div>
</template>

<script>
import Expression from "./Expression.vue";
import { imgurl } from "../common/project.config";
export default {
  props: ["data", "isService"],
  emits: ["image-load"],
  components: {
    Expression,
  },
  data() {
    return {
      showImageViewer: false,
      imageList: [],
      imageLoaded: false,
      imageFailed: false,
      imageRetry: 0,
    }
  },
  computed: {
    imageSource() {
      if (this.data.preview_url) return this.data.preview_url;
      const url = this.imageUrl(this.data.img);
      return this.imageRetry && url ? url + (url.includes('?') ? '&' : '?') + 'retry=' + this.imageRetry : url;
    },
    statusText() {
      if (this.data.status === 'failed') return this.$t(this.data.error_key || 'chat.sendFailed');
      if (this.data.status === 'uploading') return this.$t('chat.uploading') + (this.data.progress ? ' ' + this.data.progress + '%' : '');
      if (this.data.status === 'sending') return this.$t('chat.sending');
      if (this.data.status === 'waiting' || this.data.status === 'queued') return this.$t('chat.waitingConnection');
      return this.$t('chat.sent');
    },
    canRetry() {
      return !['chat.unsupportedImage', 'chat.imageTooLarge', 'chat.imageUnreadable', 'chat.imageUnavailable',
        'chat.loginExpired', 'chat.upgradeRequired', 'chat.recipientUnavailable'].includes(this.data.error_key);
    },
    // 判断是不是自己发送的
    senderIsSelf() {
      if (this.$store.state.User.id == this.data.sender_id) {
        return true;
      } else {
        return false;
      }
    },
    vip() {
      return this.$store.state.User.vip;
    },
  },
  watch: {
    imageSource(source) {
      this.imageLoaded = false;
      this.imageFailed = false;
      if (this.showImageViewer) this.imageList = [source];
    },
  },
  methods: {
    onImageLoad() {
      this.imageLoaded = true;
      this.$emit('image-load');
    },
    reloadImage() { this.imageRetry++; this.imageFailed = false; this.imageLoaded = false; },
    openImage() {
      if (!this.imageLoaded || this.imageFailed) return;
      this.imageList = [this.imageSource];
      this.showImageViewer = true;
    },
    retrySend() { this.$store.dispatch('retryChatImage', this.data.client_msg_id); },
    discardImage() { this.$store.commit('discardChatImage', this.data.client_msg_id); },
    imageUrl (file) {
      if (!file) return '';
      if (/^\/?(?:Upload|uploads)\//i.test(file)) return imgurl + file;
      return imgurl + '/member/chat_file/file?file_id=' + encodeURIComponent(file)
        + '&token=' + encodeURIComponent(localStorage.getItem('token') || '');
    },
    closeImgViewer() {
      this.showImageViewer = false
    }
  }
};
</script>

<style scoped>
.chatcontentbox {
  width: 100%;
  height: auto;
  padding-top: 10px;
  padding-bottom: 10px;
}
.pop-right {
  position: relative;
  padding: 5px 10px;
  background-color: #ffffff;
  border-radius: 5px 0 5px 5px;
  margin-right: 10px;
}

.pop-left {
  position: relative;
  padding: 5px 10px;
  background-color: #ffaa99;
  border-radius: 0 5px 5px 5px;
  margin-left: 10px;
}

.ndate {
  font-size: 13px;
  color: #999;
}
.chat-image { position: relative; min-width: 120px; min-height: 80px; }
.chat-image img { display: block; width: 120px; height: auto; max-height: 200px; object-fit: contain; cursor: pointer; }
.image-loading { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; color: #999; font-size: 12px; background: #f5f5f5; }
.image-error { width: 120px; padding: 18px 0; font-size: 12px; color: #999; }
.send-status { max-width: 180px; padding: 5px 0; font-size: 12px; color: #999; }
.send-status.failed { color: #c64242; }
button { border: 0; background: transparent; color: #bd512c; padding: 6px; cursor: pointer; font-size: 12px; }
</style>
